import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './utils/metaPixel';
initMetaPixel();
render(<App data-id="element-221" />, document.getElementById('root'));